module.exports = __webpack_public_path__ + "static/img/s6.c9ffb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s6.png
// module id = NoIn
// module chunks = 1